import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Discover & Define",
    description:
      "We start the process by defining all project requirements by crafting a strategy that aligns with your objectives.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "In the design phase, we structure your site, design elements, and user experience, visualizing the process through wireframes and prototypes.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Develop & Customize",
    description:
      "Our skilled developers bring your design to life using WordPress, customizing features and functionalities to meet your specific needs.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test & Ensure Quality",
    description:
      "To make sure your web operates properly, we conduct rigorous testing to ensure a flawless and responsive experience.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Deploy & Launch",
    description:
      "Upon approval, your website is prepared for a smooth transition to the live environment, ensuring an optimal launch experience.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Post-launch Support",
    description:
      "Our ongoing support keeps your WordPress site secure, updated, and performing at its peak through regular maintenance.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our WordPress Development <span>Process</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              We strategize, design, and code with precision, delivering a
              website that perfectly aligns with your goals and requirements.
              Here is our WordPress development process:
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
